module.exports = __webpack_public_path__ + "static/media/w_18.b62949b8.png";